import React from 'react';

function NotAllowedScreen() {
    return (
        <h1>Sem permissão</h1>
    );
}

export default NotAllowedScreen;
